import Icon from '../components/Icon.vue'

Icon.register({
  edit: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M402.6 83.2L492.8 173.4C496.6 177.2 496.6 183.4 492.8 187.2L274.4 405.6 181.6 415.9C169.2 417.3 158.7 406.8 160.1 394.4L170.4 301.6 388.8 83.2C392.6 79.4 398.8 79.4 402.6 83.2zM564.6 60.3L515.8 11.5C500.6-3.7 475.9-3.7 460.6 11.5L425.2 46.9C421.4 50.7 421.4 56.9 425.2 60.7L515.4 150.9C519.2 154.7 525.4 154.7 529.2 150.9L564.6 115.5C579.8 100.2 579.8 75.5 564.6 60.3zM384 346.2V448H64V128H293.8C297 128 300 126.7 302.3 124.5L342.3 84.5C349.9 76.9 344.5 64 333.8 64H48C21.5 64 0 85.5 0 112V464C0 490.5 21.5 512 48 512H400C426.5 512 448 490.5 448 464V306.2C448 295.5 435.1 290.2 427.5 297.7L387.5 337.7C385.3 340 384 343 384 346.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/edit.js
// module id = Vej+
// module chunks = 144